if (!customElements.get("announcement-bar-item")) {
  customElements.define(
    "announcement-bar-item",
    class extends HTMLElement {
      constructor() {
        super();

        const urlParamKey = (this.dataset.urlParam || "").trim();
        if (!urlParamKey) return;

        const urlParamValue = new URLSearchParams(window.location.search).get(
          urlParamKey,
        );
        if (!urlParamValue) return;

        const messageElement = this.querySelector(".announcement-bar__message");
        if (!messageElement) return;

        messageElement.innerHTML = this.dataset.text.replaceAll(
          "[url-param]",
          urlParamValue,
        );
      }
    },
  );
}
